var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMatchingCards(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 44,
    viewBox: "0 0 61 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#2CABE0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-284 -1027) translate(249 989) translate(35 38)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 19,
    x: 0.5,
    y: 0.5,
    fill: "#FFF",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 19,
    x: 0.5,
    y: 24.5,
    fill: "#FFF",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 19,
    x: 33.5,
    y: 0.5,
    fill: "#2CABE0",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 19,
    x: 33.5,
    y: 24.5,
    fill: "#FFF",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 19,
    x: 16.5,
    y: 0.5,
    fill: "#FFF",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 19,
    x: 16.5,
    y: 24.5,
    fill: "#2CABE0",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 19,
    x: 49.5,
    y: 0.5,
    fill: "#FFF",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 19,
    x: 49.5,
    y: 24.5,
    fill: "#FFF",
    rx: 1
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchingCards);
export default __webpack_public_path__ + "static/media/matching-cards.5859dadde87b360f02ee72851fefb0a4.svg";
export { ForwardRef as ReactComponent };